var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask2251\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient2252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.6644760292141 746.4017647076702L737.0761475386803 836.9896447486353 827.6640275796453 623.5779732391691 614.2523560701793 532.990093198204z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.9700779724674 780.3424068951665L1593.5404157936953 720.5567895478835 1533.7547984464122 412.9864517266556 1226.1844606251843 472.7720690739386z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.2931802702396 247.49182215373455L2021.063130712738 37.904817384301026 1578.7061755008062 14.721871711236105z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.9083447843552 302.19652157256974L1119.9003072629537 403.77593503358196 1516.4877582453676 597.2045590939713z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919.25,1350.129C2021.795,1349.542,2102.881,1274.971,2155.313,1186.842C2209.232,1096.215,2243.695,985,2190.739,893.807C2137.948,802.897,2024.357,778.322,1919.25,780.325C1818.319,782.248,1716.299,816.815,1665.107,903.821C1613.281,991.905,1627.889,1100.759,1678.461,1189.57C1729.625,1279.42,1815.856,1350.721,1919.25,1350.129",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.4950444047686 988.4125354178896L1792.0787668158994 942.376244068485 1529.458753055364 771.8288130067589z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.75 175.79 a259.59 259.59 0 1 0 519.18 0 a259.59 259.59 0 1 0 -519.18 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.4794830285932 877.0266863203219L1536.4064296402512 1088.100678716116 1747.480422036045 1225.173732104458 1884.5534754243872 1014.0997397086641z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask2251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient2252"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 58, 44, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(163, 20, 20, 1)",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            @keyframes float1 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-10px, 0)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float1 {\r\n                animation: float1 5s infinite;\r\n            }\r\n\r\n            @keyframes float2 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-5px, -5px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float2 {\r\n                animation: float2 4s infinite;\r\n            }\r\n\r\n            @keyframes float3 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(0, -10px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float3 {\r\n                animation: float3 6s infinite;\r\n            }\r\n        "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRed);
export default __webpack_public_path__ + "static/media/bgRed.f4c34dc40b6a6cd624e5de940401d6ff.svg";
export { ForwardRef as ReactComponent };